import React, { Component } from 'react';
import * as $ from 'jquery';
import PromocodeDialog from './PromocodeDialog.js';
import { translate } from 'react-i18next';
import Input from '../../components/Input/index.jsx';

class Summit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsValid: {},
            isPromocodeSuccess: false,
            isSubmitted: false,
            promocodeMessage: '',
            isPromocodeLoading: false
        }
    }

    handlePromocodeClick = () => {
        $('#btnPromocode').click();
    }

    renderPromocodeDialog = () => {
        return (
            <PromocodeDialog
                handleClearPromocode={this.props.handleClearPromocode}
                handlePromocodeChange={this.props.handlePromocodeChange}
                handlePromocodeSubmit={this.handlePromocodeSubmit}
                promocode={this.props.promocode}
                promocodeError={this.props.promocodeError} />
        );
    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { fieldsValid } = this.state;
        const isValid = Object.values(fieldsValid).every(field => field === true);
        if (isValid) {
            this.props.handleSummit(e);
        } else {
            alert('Por favor, llene todos los campos correctamente');
        }
    }

    handlePromocode = (e) => {
        this.getPromocode({
            token_id: this.props.getTokenId(),
            promocode: this.props.promoCode
        }).then((response) => {
            this.setState({
                promocodeMessage: "Descuento aplicado correctamente",
                isPromocodeSuccess: true
            });
        }).catch(({ data }) => {
            this.setState({
                promocodeMessage: data.msg,
                isPromocodeSuccess: false
            });
        }).finally(() => {
            this.setState({
                isSubmitted: true,
                isPromocodeLoading: false
            });
        })
    }

    getPromocode = (params) => {
        return new Promise((resolve, reject) => {
            this.props.post(
                "/checkPromocode",
                params,
                (response) => resolve(response),
                (error) => reject(error),
                '',
                (error) => reject(error)
            );
        })
    }

    handleColor = () => {
        if (!this.state.isSubmitted) {
            return null
        }
        if (this.state.isPromocodeSuccess) {
            return "var(--accent)"
        }
        return "var(--error)"
    }

    handleChangePromocode = (props) => {
        this.props.handleChangePromocode(props)
        this.setState({
            isPromocodeLoading: true
        })
    }

    render() {
        // const { t } = this.props;
        const colorPromocode = this.handleColor()
        return (
            <div className="panel-summit">
                <div className="row-auto">
                    <div className="col-md-12">
                        <form method="post" onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <h2 className="form-group-title">Datos Personales</h2>
                            </div>
                            <div className="form-group  col-md-6 col-sm-12">
                                <Input
                                    required
                                    className="form-control"
                                    id="name"
                                    value={this.props.nombre}
                                    placeholder={"Nombre(s)"}
                                    type="text"
                                    name="name"
                                    onValidate={this.handleValidate}
                                    onChange={this.props.handleChanegeName} />
                            </div>
                            <div className="form-group  col-md-6 col-sm-12">
                                <Input
                                    required
                                    className="form-control"
                                    id="lastname"
                                    value={this.props.lastname}
                                    placeholder={"Apellido(s)"}
                                    type="text"
                                    name="lastname"
                                    onValidate={this.handleValidate}
                                    onChange={this.props.handleChanegeLastName} />
                            </div>
                            <div className="form-group col-md-12 col-sm-12">
                                <Input
                                    required
                                    className={this.props.is_errorcheck ? "form-control form-control-negative" : "form-control"}
                                    id="email_summit"
                                    value={this.props.correo}
                                    placeholder={"Correo Electrónico"}
                                    type="email"
                                    name="email"
                                    onValidate={this.handleValidate}
                                    onChange={this.props.handleChanegeCorreo} />
                                {this.props.is_errorcheck
                                    ? <p>Detección de registros duplicados</p>
                                    : null}
                            </div>
                            <div className="form-group  col-md-5 col-sm-12">
                                <Input
                                    required
                                    className="form-control"
                                    id="phone_summit"
                                    value={this.props.celular}
                                    placeholder={"N° Celular (10 dígitos)"}
                                    type="tel"
                                    name="phone"
                                    onValidate={this.handleValidate}
                                    onChange={this.props.handleChanegeCelular} />
                            </div>
                            <div className="form-group  col-md-3 col-sm-12">
                                <Input
                                    required
                                    className="form-control"
                                    id="year_summit"
                                    value={this.props.edad}
                                    placeholder={"Edad"}
                                    type="number"
                                    name="year"
                                    onValidate={this.handleValidate}
                                    onChange={this.props.handleChanegeEdad} />
                            </div>
                            <div className="form-group col-md-4 col-sm-12">
                                <select
                                    required
                                    className="form-control"
                                    id="geneder_summit"
                                    onChange={this.props.handleChanegeGenero}
                                    value={this.props.genero}>
                                    <option value="">Género</option>
                                    <option value="2">Femenino</option>
                                    <option value="1">Masculino</option>
                                </select>
                            </div>
                            <div className="form-group col-md-4 col-sm-122">
                                <select
                                    required
                                    className="form-control"
                                    id="business_summit"
                                    onChange={this.props.handleEstadosChange}
                                    value={this.props.estados_id}
                                >
                                    <option value="">Estado</option>
                                    {this.props.estados && (
                                        this.props.estados.map((estado, index) =>
                                            <option key={index} value={estado.id}>{estado.name}</option>
                                        )
                                    )}
                                </select>
                            </div>

                            <div className="form-group col-md-4 col-sm-12">
                                <select
                                    required
                                    disabled={!this.props.estados_id ? true : false}
                                    className="form-control"
                                    id="business_summit"
                                    onChange={this.props.handleCuidadesListChange}
                                    value={this.props.ciudad_id}
                                // style={!this.props.estados_id ? { "fontSize": "12px", "color": "#999" } : { "fontSize": "12px" }}
                                >
                                    <option value="">Ciudad</option>
                                    {this.props.ciudades && (
                                        this.props.ciudades.map((ciudades, index) =>
                                            <option key={index} value={ciudades.id}>{ciudades.name}</option>
                                        )
                                    )}
                                </select>
                            </div>
                            <div className="form-group col-md-4 col-sm-12">
                                <select
                                    required
                                    className="form-control"
                                    id="info_summit"
                                    onChange={this.props.handleChangeEvent}
                                    value={this.props.como_se_entero}>
                                    <option value="">¿Cómo se Enteró?</option>
                                    <option value="1">Soy socio IOS</option>
                                    <option value="2">Revista</option>
                                    <option value="3">Web Digital</option>
                                    <option value="4">Referencia</option>
                                    <option value="5">Redes Sociales</option>
                                </select>
                            </div>
                            {this.props.como_se_entero === "5" ? (
                                <div className="form-group col-md-12 col-sm-12">
                                    <label htmlFor="center">Red Social</label>
                                    <select
                                        required
                                        className="form-control"
                                        id="red_social" name="red_social"
                                        onChange={this.props.handleChangeSocial}
                                        value={this.props.redSocial}>
                                        <option value="">Selecione una opción</option>
                                        <option value="1">Facebook</option>
                                        <option value="2">Instagram</option>
                                        <option value="3">Twitter</option>
                                        <option value="4">Linkedin</option>
                                    </select>
                                </div>
                            ) : null}
                            {this.props.como_se_entero === "4" ? (
                                <div className="form-group-textarea col-md-12 col-sm-12" >
                                    <label htmlFor="description">
                                        Describe la referencia
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="comentRefence"
                                        name="como_se_entero_descrp"
                                        placeholder="Referido"
                                        onChange={this.props.handleChanegeevento_descrp}
                                        value={this.props.como_se_entero_descrp}>
                                    </textarea>
                                </div>
                            ) : null}
                            <main className="row-auto">
                                <div className="form-group">
                                    <h2 className="form-group-title">Datos de la empresa</h2>
                                </div>
                                <div className="form-group  col-md-6 col-sm-12">
                                    <Input
                                        required
                                        className="form-control"
                                        id="empresa_summit"
                                        value={this.props.empresa}
                                        placeholder={"Nombre de la Empresa"}
                                        type="text"
                                        name="empresa"
                                        onValidate={this.handleValidate}
                                        onChange={this.props.handleChanegeEmpresa} />
                                </div>
                                <div className="form-group col-md-6 col-sm-12">
                                    <select
                                        required
                                        className="form-control"
                                        id="tp_empresa_summit"
                                        onChange={this.props.handleChanegetp_empresa}
                                        value={this.props.tipo_empresa}>
                                        <option value=""># Empleados</option>
                                        <option value="1">1</option>
                                        <option value="2">2 - 15</option>
                                        <option value="3">15 - 50</option>
                                        <option value="4">50 - 100</option>
                                        <option value="5">100 - 500</option>
                                        <option value="6">500 o más</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-6 col-sm-12">
                                    {/* <label htmlFor="center">
                                        PUESTO
                                    </label> */}
                                    <select
                                        required
                                        className="form-control"
                                        id="puesto_summit"
                                        onChange={this.props.handleChangePuesto}
                                        value={this.props.puesto}>
                                        <option value="">Puesto</option>
                                        <option value="1">CEO/Dueño</option>
                                        <option value="2">Director/Gerente</option>
                                        <option value="3">Ejecutivo/Colaborador</option>
                                        <option value="4">Startup</option>
                                        <option value="5">Estudiante</option>
                                        <option value="6">Prensa</option>
                                        <option value="7">Otro</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-6 col-sm-12">
                                    <select
                                        required
                                        className="form-control"
                                        id="business_summit"
                                        onChange={this.props.handlebusinesChange}
                                        value={this.props.busines}>
                                        <option value="">Línea de la empresa</option>
                                        {this.props.business ? (
                                            this.props.business.map((giro, index) =>
                                                <option key={index} value={giro.id}>{giro.name}</option>
                                            )
                                        ) : null}
                                    </select>
                                </div>
                                <h3>Código Promocional</h3>
                                <article className="col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <input
                                            style={{ border: "2px solid " + colorPromocode }}
                                            className="form-control"
                                            maxLength="16"
                                            onChange={this.handleChangePromocode}
                                            type="text"
                                            placeholder={"Ingresa promo code"}
                                            onBlur={this.handlePromocode}
                                            value={this.props.promoCode} />
                                        <aside className="flex-right" onClick={this.handlePromocode}>
                                            <i className="fa fa-circle-right" />
                                        </aside>
                                        {
                                            this.state.promocodeMessage && this.state.isPromocodeSuccess && (
                                                <p className="success-text">{this.state.promocodeMessage}</p>
                                            )
                                        }
                                        {
                                            this.state.promocodeMessage && !this.state.isPromocodeSuccess && (
                                                <p className="error-text">{this.state.promocodeMessage}</p>
                                            )
                                        }
                                    </div>
                                </article>
                                <div className="form-group col-md-6 col-sm-12">
                                    {
                                        this.state.isPromocodeLoading ? (
                                            <button
                                                disabled={this.props.ispayfree}
                                                className="btn btn-primary btn-full-width"
                                                onClick={this.handlePromocode}
                                                type="button">
                                                Validar 
                                            </button>
                                        ) : (
                                            <button
                                                disabled={this.props.ispayfree}
                                                className="btn btn-primary btn-full-width"
                                                type="submit">
                                                Continuar
                                            </button>
                                        )
                                    }
                                </div>
                            </main>
                        </form >
                    </div>
                    {this.renderPromocodeDialog()}
                </div >
            </div >
        )
    }
}

export default translate('common')(Summit);


// WEBPACK FOOTER //
// ./src/guest/summit/Summit.js